<template>
  <div>

    <!--  <sub-header :headerItems="headerItems" headColor="#7BAD34"/>-->
      <sub-slider v-if="sliderItems"  :slider-items="sliderItems"/>
<!--    <new-sub-slider :headerItems="headerItems" :sliderItems="sliderItems"/>-->

    <AboutTitle :title="$t('products')" color="success" page-route="/sub/light-blocks"/>

    <lightBlocksProducts style="margin-top: 32px;"/>
    <lightBlocksFeatures/>
    <LightBlocksDownloads/>
    <lightBlocksProjects/>


    <!--  <lightBlockCalculator/>-->
    <light-block-local-calculator/>
  </div>
</template>

<script>
import LightBlocksProducts from "./components/LightBlocksProducts";
import LightBlocksProjects from "./components/LightBlocksProjects";
import LightBlocksFeatures from "./components/LightBlocksFeatures";
import LightBlocksDownloads from "./components/LightBlocksDownloads";
import LightBlockCalculator from "./components/LightBlockCalculator";
import LightBlockLocalCalculator from "./components/LightBlockLocalCalculator";
import {mapState} from "vuex";
import NewSubSlider from "../../../components/newSubSlider/newSubSlider";
import AboutTitle from "../glass/pages/About/Components/AboutTitle";

export default {
  name: "lightWeightBlocks",
  components: {
    AboutTitle,
    NewSubSlider,
    LightBlockCalculator,
    LightBlocksDownloads,
    LightBlocksFeatures,
    LightBlocksProjects,
    LightBlocksProducts,
    LightBlockLocalCalculator
  },
  data() {
    return {
      headerItems: [
        {
          name: 'صفحه اصلی',
          type: 'single',
          route: '/',
          subDomain: []
        },
        {
          name: 'درباره ما',
          type: 'single',
          route: '/sub/light-blocks/about',
          expanded: false,
        },
        {
          name: 'اخبار',
          type: 'single',
          route: '/sub/light-blocks/news',
          expanded: false,
        },
        {
          name: 'محصولات',
          type: 'sublayer',
          route: '',
          expanded: false,
          subDomain: [
            {
              name: 'بلوک سبک اتوکلاو شده',
              route: '/sub/light-blocks/construction/product/block'
            },
            {
              name: 'آجر سیلیکان',
              route: '/sub/light-blocks/construction/product/ajor'
            },
            {
              name: 'ملات خشک ساختمانی',
              route: '/sub/light-blocks/construction/products'
            },
          ]
        },
        {
          name: 'اطلاعات فنی',
          type: 'single',
          expanded: false,
          route: '/sub/light-blocks/technical'
        },
        {
          name: 'شبکه عاملیت',
          type: 'single',
          route: '/sub/light-blocks/operation-network',
          expanded: false,

        },
        {
          name: 'تماس با ما',
          type: 'single',
          route: '/sub/light-blocks/contact-us',
          subDomain: []
        },

      ],
    }
  },
  computed: {
    ...mapState({
      // sliderItems: state => state.lightBlocksManagement.blockSlider,
      sliderItems: state => state.lightBlocksManagement.blockHomeBanner,
      lightweightBlockMenu:state => state.homeManagement.lightweightBlockMenu,
    })
  },
  created() {
    // this.$store.dispatch('lightBlocksManagement/getBlockSlider');
    this.$store.dispatch('lightBlocksManagement/getBlockHomeBanner');
    this.$store.dispatch('lightBlocksManagement/getBlockHomeNewBanner');
    this.$store.dispatch('lightBlocksManagement/getBlockHomeCatalogue');
    this.$store.dispatch('lightBlocksManagement/getBlockHomeFeatures');
    this.$store.dispatch('lightBlocksManagement/getBlockNews', {
      page: 1
    });
    this.$store.dispatch('lightBlocksManagement/getBlockProjects', {
      page: 1,
    });
    
    // this.$store.dispatch('lightBlocksManagement/getBlockProducts');
  }
}
</script>

